import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PostAddIcon from '@mui/icons-material/PostAdd';
import {ClickAwayListener} from '@mui/base';
import { StyledPaper } from './SettingsDropDown.styles';

export function AdvancedSettingsMenu({
  setOpenOrganizationMenu,
  openOrganizationMenu,
  openAdvancedSettings,
  setOpenAdvancedSettings,
  setOpenMenu,
  openMenu,
}: AdvancedSettingsMenuProps) {
  function handleOrganizations() {
    setOpenOrganizationMenu(!openOrganizationMenu);
    setOpenAdvancedSettings(!openAdvancedSettings);
  }
  function handleAdvancedSettingsClick() {
    setOpenAdvancedSettings(!openAdvancedSettings);
    setOpenMenu(!openMenu);
  }
  function handleClose() {
    setOpenAdvancedSettings(!openAdvancedSettings);
  }

  function handleClickAway() {
    setOpenAdvancedSettings(false);
  }
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <StyledPaper>
        <MenuList>
          <MenuItem onClick={handleAdvancedSettingsClick}>
            <ListItemIcon>
              <KeyboardArrowLeftIcon htmlColor='#000000' />
            </ListItemIcon>
            <ListItemText>
              <b>Advanced settings</b>
            </ListItemText>
          </MenuItem>
          <MenuItem>
            <ListItemIcon>
              <EventAvailableIcon htmlColor='#000000' />
            </ListItemIcon>
            <ListItemText onClick={handleClose}>Events</ListItemText>
            <Typography variant='body2' color='text.secondary'>
              <KeyboardArrowRightIcon htmlColor='#000000' />
            </Typography>
          </MenuItem>
          <MenuItem onClick={handleOrganizations}>
            <ListItemIcon>
              <PeopleAltIcon htmlColor='#000000' />
            </ListItemIcon>
            <ListItemText>Organizations</ListItemText>
            <Typography variant='body2' color='text.secondary'>
              <KeyboardArrowRightIcon htmlColor='#000000' />
            </Typography>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <PostAddIcon htmlColor='#000000' />
            </ListItemIcon>
            <ListItemText>Post and activites</ListItemText>
            <Typography variant='body2' color='text.secondary'>
              <KeyboardArrowRightIcon htmlColor='#000000' />
            </Typography>
          </MenuItem>
        </MenuList>
      </StyledPaper>
    </ClickAwayListener>
  );
}
